import { userInfoSync } from 'hub-http/userInfo';
import memoize from 'react-utils/memoize';
import memoizeOne from 'react-utils/memoizeOne';
const convertToSet = memoizeOne(gates => new Set(gates));
const emptySet = new Set();
export const getGatesSync = () => {
  try {
    // WARN: ignoreRedirect is important! Without it, any consumers that don't
    // support or shim userInfo can end up redirecting (the default behavior).
    // This has caused past critsits:
    // https://git.hubteam.com/HubSpot/Critsit/issues/3557
    // https://git.hubteam.com/HubSpot/Critsit/issues/1040
    const {
      gates
    } = userInfoSync({
      ignoreRedirect: true
    });
    return convertToSet(gates);
  } catch (e) {
    return emptySet;
  }
};

// @ts-expect-error these types require a string | number, but this will work with just a string
export const hasGateSync = memoize(gate => {
  const gateWithoutPrefix = gate.replace(/^g8:/, '');
  const params = new URLSearchParams(window.location.search);
  const ungatedParam = params.get('ungated');
  const gatedParam = params.get('gated');
  const hasUngated = ungatedParam === gateWithoutPrefix || ungatedParam === '';
  const hasGated = gatedParam === gateWithoutPrefix || gatedParam === '';
  return !hasGated && (getGatesSync().has(gate) || hasUngated);
});